const EventEmitter = require('eventemitter3');

const BattleCalc = require('../../BattleCalc');
const GainMPEvent = require('../../events/GainMPEvent');
const { logError } = require('../../logger');

const MysticFocus = function(battleState) {
  this.handle = 'mystic_focus';
  this.magic = true;
  this.help = true;

  this.eventEmitter = new EventEmitter();

  this.isLegal = function() {
    return true;
  };

  this.execute = function(actor, victim) {
    if (!actor || !actor.inPlay) {
      return { success: false };
    }

    try {
      var finalPotency = Math.floor(BattleCalc.getEquippedAbility(actor,'mystic_focus').potency);
      if (finalPotency > actor.max_mp - actor.mp) {
        finalPotency = actor.max_mp - actor.mp;
      }

      const gainMP = new GainMPEvent(battleState, finalPotency);
      gainMP.execute(actor);
      gainMP.actorId = actor.uid;
      gainMP.victimId = actor.uid;

      var result = { gainMP };
      result.abilityHandle = this.handle;
      result.actorId = actor.uid;
      result.allPieces = battleState.allPieces;
      this.eventEmitter.emit('result', result);
    } catch (err) {
      logError(err, {
        module: 'MysticFocus',
        func: 'execute',
        actor,
        victim,
      });
      return { success: false };
    }
  };
};
module.exports = MysticFocus;
